'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import SvgChevronright from '@common/icon/SvgChevronright';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
import type { MarketProduct } from '../types';
interface DonationGiftBannerProps {
  product: MarketProduct;
  className?: string;
}
export const DonationGiftBanner = t0 => {
  const $ = _c(12);
  const {
    product,
    className
  } = t0;
  if (!product.giftProductNumber) {
    return null;
  }
  const t1 = `flex items-center justify-between gap-16 bg-Gray-black px-32 py-25 ${className ?? ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Badge className="bg-O-400 font-600 text-Gray-white typo-caption2">고향사랑기부</Badge>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `${product.govCodeName}에 기부시\n${product.productName} 0원`;
  let t4;
  if ($[1] !== t3) {
    t4 = <div className="flex min-w-0 flex-col items-start gap-8">{t2}<p className="line-clamp-2 whitespace-pre-line font-700 text-Y-50 typo-body3">{t3}</p></div>;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== product.giftProductNumber) {
    t5 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: product.giftProductNumber
    });
    $[3] = product.giftProductNumber;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SvgChevronright className="size-12 mobile-tablet:size-10" />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5) {
    t7 = <CustomLink href={t5} className="flex shrink-0 items-center justify-center gap-4 self-end rounded-xxsmall pb-4 font-700 text-O-400 typo-caption1 hover:opacity-80 mobile-tablet:typo-caption2">기부하고 답례품받기{t6}</CustomLink>;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t1 || $[9] !== t4 || $[10] !== t7) {
    t8 = <section className={t1}>{t4}{t7}</section>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};